export default "__VITE_ASSET__dfeb0e09__"